














































































































import { Component } from 'vue-property-decorator';
import CommonMixin from "@/utils/CommonMixin";
import cr from "@/CompositionRoot";
import _ from "lodash";
import { EsText, EventReg, EventRegStateDto, Form, FormField, ShowRegItemsStateDto } from "frontend-common";
import TextEditor from "@/components/dashboard/common/TextEditor.vue";
import { FormSelectOptions } from "@/utils/misc";
import AddField from "@/components/dashboard/AddField.vue";
import vuedraggable from "vuedraggable";
import SelectFormField from "@/components/dashboard/SelectFormField.vue";
import FormFieldRow from "@/components/dashboard/reg/FormFieldRow.vue";
import EditRemovePanel from "@/components/dashboard/common/EditRemovePanel.vue";

@Component({
    components: { EditRemovePanel, FormFieldRow, SelectFormField, AddField, TextEditor, vuedraggable }
})
export default class extends CommonMixin {

    private regDraft: EventReg = new EventReg(new Form(EsText.createEmpty(), EsText.createEmpty()))
    private progressEnable = false
    private progress = false
    private dragIndex = -1

    created() {
        this.onReset()
    }

    mounted() {
        const route = this.$route
        const refs = this.$refs
        const regEnabled = this.regEnabled
        setTimeout(function () {
            if (!route.meta?.fromHistory && !regEnabled && refs.enable) {
                (refs.enable as HTMLElement).focus()
            }
        }, 100)

        this.bindShortcuts()
        this.addOnEscapeListener(() => this.$router.push(this.toEvent(this.uuid)))
        this.addOnSaveListener(() => this.onSubmit())
    }

    get uuid(): string {
        return this.$route.params.uuid
    }

    get reg(): EventReg {
        return cr.myEventsModule.regByEvent(this.uuid)
    }

    get regEnabled(): boolean {
        return this.regDraft.state !== EventRegStateDto.DISABLED
    }

    get showRegItemsEnabled(): boolean {
        return this.regDraft.showRegItemsState !== ShowRegItemsStateDto.DISABLED
    }

    get commonProgress(): boolean {
        return this.progressEnable || this.progress
    }

    onEnableClicked() {
        this.progressEnable = true
        const tempReg = _.cloneDeep(this.reg)
        tempReg.showRegItemsState = ShowRegItemsStateDto.DRAFT
        return cr.myEventsService.updateEventRegOnly(this.uuid, tempReg)
            .then(value => this.onReset())
            .catch(reason => {
                this.onReset()
                this.showError(reason)
            })
            .finally(() => this.progressEnable = false)
    }

    onDisableClicked() {
        this.disableShortcuts()
        this.$bvModal.msgBoxConfirm(this.$t("dashboard.regItemsPublic.disable.confirm") as string, {
            title: this.$t("dashboard.regItemsPublic.disable.title") as string,
            okVariant: "outline-danger",
            okTitle: this.$t("dashboard.common.disable") as string,
            cancelVariant: "outline",
            cancelTitle: this.$t("dashboard.common.cancel") as string,
            centered: true,
        }).then(result => {
            this.enableShortcuts()
            this.progressEnable = true
            if (result) {
                const tempReg = _.cloneDeep(this.reg)
                tempReg.showRegItemsState = ShowRegItemsStateDto.DISABLED
                return cr.myEventsService.updateEventRegOnly(this.uuid, tempReg)
                    .then(value => this.onReset())
                    .catch(reason => {
                        this.onReset()
                        this.showError(reason)
                    })
                    .finally(() => this.progressEnable = false)
            }
        }).finally(() => this.progressEnable = false)
    }

    startDrag(event: any) {
        this.dragIndex = event.oldIndex
    }

    endDrag() {
        this.dragIndex = -1
    }

    fieldById(fieldId: number): FormField | undefined {
        return this.regDraft.form.fields.find(field => field.id === fieldId)
    }

    get hasChanges(): boolean {
        return this.regDraft.showRegItemsState !== this.reg.showRegItemsState
            || this.regDraft.showRegItemsName !== this.reg.showRegItemsName
            || this.regDraft.showRegItemsDate !== this.reg.showRegItemsDate
            || !_.isEqual(this.regDraft.showRegItemsFieldIds, this.reg.showRegItemsFieldIds)
    }

    onReset() {
        this.regDraft = _.cloneDeep(this.reg)
    }

    onSubmit(onSuccess: Function | null = null) {
        if (this.hasChanges) {
            this.progress = true
            cr.myEventsService.updateEventRegOnly(
                this.uuid,
                this.regDraft
            )
                .then(value => {
                    this.progress = false
                    this.onReset()
                    if (onSuccess) {
                        onSuccess()
                    }
                })
                .catch(reason => {
                    this.progress = false
                    this.showError(reason)
                })
        }
    }

    stateOptions(): FormSelectOptions {
        return [
            {
                value: ShowRegItemsStateDto.DRAFT,
                text: this.$t("dashboard.regItemsPublic.form.state.valueDraft") as string
            },
            {
                value: ShowRegItemsStateDto.ENABLED,
                text: this.$t("dashboard.regItemsPublic.form.state.valueEnabled") as string
            },
        ]
    }

    onFieldAdded(field: FormField) {
        this.regDraft.showRegItemsFieldIds.push(field.id)
        this.$bvModal.hide("selectFormField")
    }

    onFieldAddCancelled() {
        this.$bvModal.hide("selectFormField")
    }

    removeField(index: number) {
        this.regDraft.showRegItemsFieldIds.splice(index, 1)
    }

    beforeRouteLeave(to: Location, from: Location, next: Function) {
        if (!this.hasChanges) {
            next()
            return
        }
        this.disableShortcuts()
        this.confirmSave().then(result => {
            this.enableShortcuts()
            if (result != null) {
                result ? this.onSubmit(next) : next()
            }
        })
    }
}
